.panel {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-3);
  align-items: center;
  padding: var(--tuna-spacing-4);
}

.header {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}

.score {
  color: var(--tuna-content-secondary);
  font-size: var(--tuna-typography-body2-fontSize);
}

.prompt {
  font-size: var(--tuna-typography-h3-fontSize);
  text-align: center;
  margin: 0;
}

.hearItButton {
  min-width: 160px;
}

.answers {
  display: flex;
  gap: var(--tuna-spacing-3);
}
